export default __webpack_public_path__ + "static/media/star-rating-high-performer.c1275410.svg";